module.exports = __webpack_public_path__ + "3aa2d7745074b1d8b045d06ffdfbae7b.woff";